import React from 'react';
import BuildActions from '../builder/action/builderActions';
import { findIndex } from 'underscore';
import clone from 'clone';
import panelActions from './action/panelActions';

class MapPanel extends React.Component {
    constructor(props) {
      super(props);
      this.valueIncrementLayout = this.valueIncrementLayout.bind(this);
      this.valueDecrementLayout = this.valueDecrementLayout.bind(this);
      this.handleCheckedMarkerTemplate = this.handleCheckedMarkerTemplate.bind(this);
      this.handleCheckedMarkerIcon = this.handleCheckedMarkerIcon.bind(this);
      this.handleHight = this.handleHight.bind(this);
      this.handleZoom = this.handleZoom.bind(this);
      this.displayName = 'MapPanel';
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.block = _.where(this.props.allLayout, { uid: this.props.uid });
      this.state = {
        'helperData': clone(this.props.helperData),
      };
      this.allLayout = {};
    }
    componentWillMount() {
      this.block = _.where(this.props.allLayout, { uid: this.props.uid });

      if (this.block) {
        const value = this.block[0].hight ? parseInt(this.block[0].hight, 10) : 500;
        const zoomIn = this.block[0].zoom ? parseInt(this.block[0].zoom, 10) : 3;
        this.block = this.block[0];
        const markerTemplate = [];
        this.FlagMarkerTemplate = false;
        this.FlagMarkerIcon = false;
        this.allLayout = clone(this.props.allLayout);
        for (const key in ReactiveMarkerTemplate) {
          if (ReactiveMarkerTemplate.hasOwnProperty(key)) {
            const temp = {};
            temp.key = key;
            temp.value = key;
            if (this.block.markerTemplate !== key.toString()) {
              temp.isChecked = false;
            } else {
              this.FlagmarkerTemplate = true;
              temp.isChecked = true;
            }
            markerTemplate.push(temp);
          }
        }
        if (this.FlagMarkerTemplate === false) {
          const index = findIndex(markerTemplate, { key: 'default' });
          if (index !== -1) {
            markerTemplate[index].isChecked = true;
          }
        }
        const markerIcon = [];
        for (const key in ReactiveMarkerIcon) {
          if (ReactiveMarkerIcon.hasOwnProperty(key)) {
            const temp = {};
            temp.key = key;
            temp.value = key;
            if (this.block.markerIcon !== key.toString()) {
              temp.isChecked = false;
            } else {
              this.FlagMarkerIcon = true;
              temp.isChecked = true;
            }
            markerIcon.push(temp);
          }
        }
        if (this.FlagMarkerIcon === false) {
          const index = findIndex(markerTemplate, { key: 'default' });
          if (index !== -1) {
            markerIcon[index].isChecked = true;
          }
        }
        this.setState({ ...this.block, value, markerTemplate, markerIcon, zoomIn });
      }
    }
    // Note:  per update won't chnage the whole preview , only save button will change the preview .
    handleSubmitLayout() {
      if (_.isEmpty(this.allLayout)) {
        return;
      }
      const pushLayout = {
        'allLayout': this.allLayout,
        'shortcodeKey': this.props.shortcodeKey,
        reload: true,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    valueIncrementLayout() {
      let value = parseInt(this.state.layout, 10);
      if ((value + 1) > 12) {
        return;
      }
      value += 1;
      // this.allLayout = clone(this.props.allLayout);
      const index = findIndex(this.allLayout, { uid: this.props.uid });
      if (index !== -1) {
        this.allLayout[index].layout = value;
        this.setState({ layout: value });
      }
      if (this.layoutType !== undefined) {
        this.setState({ errorMsg: null });
      }
    }
    valueDecrementLayout() {
      let value = parseInt(this.state.layout, 10);
      if ((value - 1) < 1) {
        return;
      }
      value -= 1;
      // this.allLayout = clone(this.props.allLayout);
      const index = findIndex(this.allLayout, { uid: this.props.uid });
      if (index !== -1) {
        this.allLayout[index].layout = value;
        this.allLayout[index].hight = this.state.value;
        this.setState({ layout: value, value: this.state.value });
      }
      if (this.layoutType !== undefined) {
        this.setState({ errorMsg: null });
      }
    }
    handleHight(e) {
      e.preventDefault();
      this.allLayout = clone(this.props.allLayout);
      const index = findIndex(this.allLayout, { uid: this.props.uid });
      if (index !== -1) {
        this.allLayout[index].hight = e.target.value;
        this.setState({ value: e.target.value });
      }
    }
    handleZoom(e) {
      this.allLayout = clone(this.props.allLayout);
      const index = findIndex(this.allLayout, { uid: this.props.uid });
      if (index !== -1 && e.target.value >= 1) {
        this.allLayout[index].zoom = e.target.value;
        this.setState({ zoomIn: e.target.value });
      }
    }
    handleCheckedMarkerTemplate(e) {
      // this.allLayout = clone(this.props.allLayout);
      const markerTemplate = this.state.markerTemplate;
      const index = findIndex(this.allLayout, { uid: this.props.uid });
      if (index !== -1) {
        markerTemplate.map((item) => {
          if (item.value === e.target.value.toString()) {
            item.isChecked = true;
          } else {
            item.isChecked = false;
          }
        });
        this.allLayout[index].markerTemplate = e.target.value;
        this.setState({ markerTemplate });
      }
    }
    handleCheckedMarkerIcon(e) {
      // this.allLayout = clone(this.props.allLayout);
      const markerIcon = this.state.markerIcon;
      const index = findIndex(this.allLayout, { uid: this.props.uid });
      if (index !== -1) {
        markerIcon.map((item) => {
          if (item.value === e.target.value.toString()) {
            item.isChecked = true;
          } else {
            item.isChecked = false;
          }
        });
        this.allLayout[index].markerIcon = e.target.value;
        this.setState({ markerIcon });
      }
    }
    handleWrapperClass(value) {
      const find = findIndex(this.allLayout, { uid: this.props.uid });
      if (find !== -1) {
        this.allLayout[find].mapWrapperClass = value;
        this.setState({ mapWrapperClass: value });
      }
    }
    render() {
      const showMarkerTemplate = (item, index) => {
        return (<li className="search-content" key={'mappanel-' + index}>
          <input type="radio" name="search-markerElement" checked={item.isChecked} id={'markerStyle-' + index} value={item.key}
            onChange={this.handleCheckedMarkerTemplate}
          />
          <label className="select-search-content" htmlFor={'markerStyle-' + index}>
            <span>{item.value}</span>
          </label>
        </li>);
      };
      const showMarkerIcon = (item, index) => {
        return (<li className="search-content" key={'markericon-' + index}>
          <input type="radio" name="search-iconElement" checked={item.isChecked} id={'iconStyle-' + index} value={item.key}
            onChange={this.handleCheckedMarkerIcon}
          />
          <label className="select-search-content" htmlFor={'iconStyle-' + index}>
            <span>{item.value}</span>
          </label>
        </li>);
      };
      return (<div>
        <button className="layout-save-button" onClick={this.handleSubmitLayout.bind(this)}><i className="fa fa-floppy-o"></i><span>{API.LANG.SAVE}</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#general" aria-controls="general" role="tab" data-toggle="tab">{API.LANG.SETTINGS}</a></li>
            <li role="presentation"><a href="#appearence" aria-controls="appearence" role="tab" data-toggle="tab">{API.LANG.APPEARANCE}</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="general">
              <div className="grid-choose-option">
                <div className="flex-row">
                  <div className="flex-sm-3 flex-xs-12">
                    <div className="flex-row">
                      <div className="flex-sm-3 flex-xs-12">
                        <span className="caption">{API.LANG.CHANGE_MAP_LAYOUT}</span>
                      </div>
                      <div className="flex-sm-9 flex-xs-12">
                        <div className="choose-grid-button">
                          <p><button onClick={ this.valueIncrementLayout }><i className="fa fa-plus"></i></button></p>
                          <p><button onClick={ this.valueDecrementLayout }><i className="fa fa-minus"></i></button></p>
                          <p className="gird-value-count">
                            { this.state.layout !== undefined ? this.state.layout : null }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-sm-5 flex-xs-12">
                    <input type="text" value={this.state.mapWrapperClass} className="reactive-input" onChange={ (node) => { this.handleWrapperClass(node.target.value); }} placeholder={API.LANG.WRAPPER_CLASS_MAP}/>
                  </div>
                </div>
              </div>
              <div className="grid-choose-option">
                <div className="flex-row">
                  <div className="flex-sm-3 flex-xs-12 flex-md-2">
                    <span className="caption">{API.LANG.CHANGE_HEIGHT}</span>
                  </div>
                  <div className="flex-sm-5 flex-md-5 flex-xs-12">
                    <input type="number" className="form-control" value={this.state.value} onChange={this.handleHight}/>
                  </div>
                </div>
              </div>
              <div className="grid-choose-option">
                <div className="flex-row">
                  <div className="flex-sm-3 flex-xs-12 flex-md-2">
                    <span className="caption">{API.LANG.ZOOM}</span>
                  </div>
                  <div className="flex-sm-5 flex-md-5 flex-xs-12">
                    <input type="number" className="form-control" value={this.state.zoomIn} onChange={this.handleZoom}/>
                  </div>
                </div>
              </div>
            </div>
            <div role="tabpanel" className="tab-pane" id="appearence">
              <div className="flex-row">
                <div className="flex-sm-6 flex-xs-12">
                  <div className="grid-choose-option">
                    <span className="caption">{API.LANG.MARKER_TEMPLATE}</span>
                    <div>
                      <ul className="list-inline"> {this.state.markerTemplate.map(showMarkerTemplate)}</ul>
                    </div>
                  </div>
                </div>
                <div className="flex-sm-6 flex-xs-12">
                  <div className="grid-choose-option">
                    <span className="caption">{API.LANG.ICON_TEMPLATE}</span>
                    <div>
                      <ul className="list-inline"> {this.state.markerIcon.map(showMarkerIcon)}</ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {
        // save button for all saving, excluding `post_types`
        }
      </div>);
    }

}

MapPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
};
export default MapPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/mapPanel.js
 **/